import { render } from "./FieldCreator.vue?vue&type=template&id=3221e148"
import script from "./FieldCreator.vue?vue&type=script&lang=js"
export * from "./FieldCreator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__